import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context } from "../core/components/commonApp.js";
import { Grid } from "../core/components/grid.js";
import { Helper } from "../core/util/helper.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Reminder } from "../reminders/reminders.js";
import React from "react";

export class History extends React.Component<ReminderHistoryAppProps, any> {
    private _gridData: Array<Reminder> = [];
    private _selectedItem = null;
    common = new AppHelper();
    reminderHistoryGridOptions: kendo.ui.GridOptions;
    selectEnabled = false;
    showSelect = false;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.showSelect = this.props.selectMode === true;
    }


    private _setGridData = (data: Array<Reminder>) => {
        Helper.setArrayValues(this._gridData, data);
        for (let i = 0; i < this._gridData.length; i++) {
            if (Helper.hasValue(this._gridData[i].DueDate)) {
                this._gridData[i].DueDate = Helper.dates.toDate(this._gridData[i].DueDate);
            }
            if (Helper.hasValue(this._gridData[i].DateAdded)) {
                this._gridData[i].DateAdded = Helper.dates.toDate(this._gridData[i].DateAdded);
            }
            if (Helper.hasValue(this._gridData[i].ReadAt)) {
                this._gridData[i].ReadAt = Helper.dates.toDate(this._gridData[i].ReadAt);
            }
        }
        this.setState({});
    }

    private _getGridData = () => {
        HTTPService.get<JsonResultClass<Reminder[]>>("Tasks/GetHistory/" + this.props.reminderId)
            .then(result => {
                this._setGridData(result.Data);
            });
    }

    private _selectionChanged = (dataItem) => {
        const prevSelectEnabled = this.selectEnabled;
        this.selectEnabled = Helper.hasValue(dataItem);
        this._selectedItem = dataItem;
        if (prevSelectEnabled !== this.selectEnabled) {
            this.setState({});
        }
    }


    select = () => {
        if (Helper.hasValue(this._selectedItem)) {
            //this.common.modalContainer.trigger("itemSelected", this._selectedItem);
            //this.common.modalContainer.close();
            this.common.sheetWrapper.trigger(SheetEventType.RowClicked, this._selectedItem);
            this.common.sheetWrapper.hide();
        }
    }

    createGrid = () => {
        return (
            <div className="flex-container">
                <div className="flex-container__item flex-containter" >
                    <Grid data={this._gridData} options={this.reminderHistoryGridOptions} onSelectionChanged={this._selectionChanged} id="remindersHistory" />
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (Array.isArray(this.props.existingData)) {
            this._setGridData(this.props.existingData);
        } else {
            this._getGridData();
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this._selectionChanged });
        return <CommonApp {...props} />;
    }
}

interface ReminderHistoryContext extends Context {
    contextType: string;
}

export interface ReminderHistoryAppProps extends AppBaseProps {
    existingData?: Reminder[];
    reminderId?: string;
    context: ReminderHistoryContext;
    selectMode: boolean;
}